import { render, staticRenderFns } from "./addDaHuoB2BCK.vue?vue&type=template&id=359f5f20&scoped=true&"
import script from "./addDaHuoB2BCK.vue?vue&type=script&lang=js&"
export * from "./addDaHuoB2BCK.vue?vue&type=script&lang=js&"
import style0 from "./addDaHuoB2BCK.vue?vue&type=style&index=0&id=359f5f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f5f20",
  null
  
)

export default component.exports